module.exports = __webpack_public_path__ + "img/help_dataset_immune2.942b8a32.png";